import { MapState } from 'src/app/interfaces/map.interface';
import { SearchAggregationBucket, SearchNestedAggregation } from 'src/app/swagger-api';
import { SearchResultAggregation } from 'src/app/swagger-api/model/searchResultAggregation';
import { AggregationKey, BucketTooltip } from '../../map.interfaces';
import MapSettings from '../../map.settings';
import { AggregationProcessorType, SharedResponseProcessorDecorator } from './shared-response-processor.decorator';
import { NestedBucketOrganizationType } from '../../map.enum';

export class OrganizationAggregationResponseProcessorDecorator extends SharedResponseProcessorDecorator<SearchResultAggregation> {
  public constructor(entity: AggregationProcessorType, state: MapState) {
    super(entity, state);
  }

  public getProcessedItems(): SearchResultAggregation[] {
    this.entity.getProcessedItems().forEach((searchResultAggregation: SearchResultAggregation) => {
      searchResultAggregation.buckets.forEach((bucket: SearchAggregationBucket) => {
        this.processAggregationBucket(bucket);
      });
    });

    return this.entity.getProcessedItems();
  }

  private processNestedAggregation(nestedAggregation: SearchNestedAggregation) {
    nestedAggregation.nested_buckets.forEach((aggregationBucket: SearchAggregationBucket) =>
      this.processAggregationBucket(aggregationBucket),
    );
  }

  private processAggregationBucket(bucket: SearchAggregationBucket): void {
    if (!bucket.nested_aggregations) {
      return;
    }

    const featureBucketAggregation: SearchNestedAggregation[] = this.filterFeatureBucketAggregation(
      bucket.nested_aggregations,
    );
    featureBucketAggregation.forEach((featureBucket: SearchNestedAggregation) => {
      this.addTooltipFromFeatureBucket(bucket, featureBucket);
    });

    bucket.nested_aggregations.forEach((nestedAggregation: SearchNestedAggregation) =>
      this.processNestedAggregation(nestedAggregation),
    );
  }

  private addTooltipFromFeatureBucket(bucket: SearchAggregationBucket, featureBucket: SearchNestedAggregation): void {
    if (!featureBucket.nested_buckets) {
      return;
    }

    const sortedBuckets = this.sortNestedBuckets(featureBucket.nested_buckets);
    sortedBuckets
      .map((aggregationBucket: SearchAggregationBucket) => ({
        name: (aggregationBucket.aggregation_key as AggregationKey).name,
        value: aggregationBucket.aggregated_items_count,
      }))
      .forEach((tooltip: BucketTooltip) => {
        (bucket.aggregation_key as AggregationKey).tooltips.push(tooltip);
      });
  }

  private sortNestedBuckets(nested_buckets: SearchAggregationBucket[]): SearchAggregationBucket[] {
    // note: there is a way to move this logic to BE part, but it's more complicated
    const specificOrder = [
      NestedBucketOrganizationType.FOUNDATION,
      NestedBucketOrganizationType.INSTITUTE,
      NestedBucketOrganizationType.HOSPITAL,
      NestedBucketOrganizationType.RESEARCH_CENTER,
      NestedBucketOrganizationType.OTHER,
    ];
    const sortedBuckets: SearchAggregationBucket[] = [];

    specificOrder.forEach((aggregationType: string) => {
      nested_buckets.forEach((aggregationBucket: SearchAggregationBucket) => {
        if ((aggregationBucket.aggregation_key as AggregationKey)?.name === aggregationType) {
          sortedBuckets.push(aggregationBucket);
        }
      });
    });

    return sortedBuckets;
  }

  private filterFeatureBucketAggregation(nestedAggregations: SearchNestedAggregation[]): SearchNestedAggregation[] {
    const aggregationFeatures: SearchNestedAggregation[] = [];
    nestedAggregations.forEach((nestedAggregation: SearchNestedAggregation, index: number) => {
      if (nestedAggregation.nested_bucket_name == MapSettings.ORGANIZATION_TAB_NESTED_AGGREGATE_ATTR_NAME) {
        aggregationFeatures.push(...nestedAggregations.splice(index, 1));
      }
    });
    return aggregationFeatures;
  }
}
